module.exports = __webpack_public_path__ + "img/school1.3dc865fb.jpeg";